"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.importKitchenCounters = exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const kitchenCountersService_1 = require("./service/kitchenCountersService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)("kitchenCounters/fetch", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const kitchenCountersService = new kitchenCountersService_1.KitchenCountersService(Env_1.APIPATHENV);
        const response = yield kitchenCountersService.fetch(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error fetching kitchen counters");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)("kitchenCounters/create", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const kitchenCountersService = new kitchenCountersService_1.KitchenCountersService(Env_1.APIPATHENV);
        const response = yield kitchenCountersService.create(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error creating kitchen counter");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)("kitchenCounters/update", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const kitchenCountersService = new kitchenCountersService_1.KitchenCountersService(Env_1.APIPATHENV);
        const response = yield kitchenCountersService.update(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error updating kitchen counter");
    }
}));
exports.importKitchenCounters = (0, toolkit_1.createAsyncThunk)("kitchenCounters/import", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const kitchenCountersService = new kitchenCountersService_1.KitchenCountersService(Env_1.APIPATHENV);
        const response = yield kitchenCountersService.importCsv(payload);
        return response;
    }
    catch (error) {
        throw new Error(error.message || "Error importing kitchen counters");
    }
}));
